const __version__ ='ssq_v1.0.0'

module.exports = {
    __version__
}

